import React from 'react';
import { MapPin, Instagram, Clock, Flame } from 'lucide-react';
import { companyInfo } from '../data/mock';

const ContactSection = () => {
  const openChatbot = () => {
    window.dispatchEvent(new CustomEvent('open-chatbot', { detail: { context: '' } }));
  };

  return (
    <section id="contact" className="py-20 bg-stone-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left - Contact Info */}
          <div>
            <span className="text-amber-500 font-semibold text-sm tracking-wider uppercase">Contato</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-6">
              Fale com a <span className="text-amber-500">Rotativa Gaúcha</span>
            </h2>
            <p className="text-stone-400 mb-8">
              Tire suas dúvidas, faça seu pedido ou peça um orçamento personalizado. Estamos prontos para atender você!
            </p>

            {/* Contact Cards */}
            <div className="space-y-4">
              <a
                href={companyInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-stone-900/50 rounded-xl border border-stone-700/50 hover:border-pink-500/50 transition-all group"
              >
                <div className="w-12 h-12 bg-pink-600/20 rounded-xl flex items-center justify-center group-hover:bg-pink-600/30 transition-colors">
                  <Instagram className="w-6 h-6 text-pink-500" />
                </div>
                <div>
                  <p className="text-stone-500 text-sm">Instagram</p>
                  <p className="text-white font-semibold">@rotativagaucha</p>
                </div>
              </a>

              <div className="flex items-center gap-4 p-4 bg-stone-900/50 rounded-xl border border-stone-700/50">
                <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-amber-500" />
                </div>
                <div>
                  <p className="text-stone-500 text-sm">Localização</p>
                  <p className="text-white font-semibold">{companyInfo.fullAddress}</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-stone-900/50 rounded-xl border border-stone-700/50">
                <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center">
                  <Clock className="w-6 h-6 text-blue-500" />
                </div>
                <div>
                  <p className="text-stone-500 text-sm">Horário de Atendimento</p>
                  <p className="text-white font-semibold">Seg - Sex: 8h às 18h</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - CTA Card */}
          <div className="flex items-center justify-center">
            <div className="bg-gradient-to-br from-amber-500/10 to-stone-900 rounded-3xl p-8 border border-amber-500/30 text-center max-w-md w-full">
              <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Flame className="w-10 h-10 text-amber-500" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Pronto para ter sua Rotativa?
              </h3>
              <p className="text-stone-400 mb-6">
                Faça seu pedido agora mesmo pelo WhatsApp e garanta o melhor churrasco da região!
              </p>
              <button
                data-testid="contact-cta-btn"
                onClick={openChatbot}
                className="w-full bg-green-600 hover:bg-green-700 text-white py-4 rounded-xl font-bold text-lg transition-all hover:scale-105 hover:shadow-lg hover:shadow-green-600/30 flex items-center justify-center gap-3"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Fazer um Orçamento
              </button>
              <p className="text-stone-500 text-sm mt-4">
                Respondemos em até 2 horas!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
